// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountViewStyles } from "@steiner/Overrides/Widgets/MyAccount/MyAccountView";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.mainContainer = {
    css: css`
        &&& {
            display: grid;
            column-gap: 20px;
            grid-template-areas:
                "nav pageTitle"
                "nav dashboard"
                "cards dashboard"
                ". dashboard";
            grid-template-columns: 290px 1fr;
            ${xScreen("lte", "md")} {
                display: flex;
                flex-direction: column;
            }
        }
    `,
};

myAccountViewStyles.pageTitleGridItem = {
    css: css`
        grid-column: 1;
        grid-area: pageTitle;
    `,
};

myAccountViewStyles.quickLinksGridItem = {
    css: css`
        grid-column: 1;
        grid-area: nav;
        padding-bottom: 24px;
        ${xScreen("lte", "sm")} {
            padding-bottom: 0;
        }
    `,
};

myAccountViewStyles.extraCardsGridItem = {
    css: css`
        grid-column: 1;
        grid-area: cards;
        width: 100%;
    `,
};

myAccountViewStyles.mainSectionGridItem = {
    css: css`
        grid-column: 2;
        grid-row: 1;
        grid-area: dashboard;

        display: flex;
        flex-direction: column;
        gap: 12px;
        max-width: 100%;
        overflow: hidden;
    `,
};

myAccountViewStyles.welcomeWidgetsGridItem = {};

myAccountViewStyles.accountMessagesGridItem = {
    ...myAccountViewStyles.accountMessagesGridItem,
    css: css`
        padding: 8px 0 20px;
    `,
};
